export interface SpinnerInterface {
  showSpinner: boolean;
}

export const initSpinnerInterfaceState: SpinnerInterface = {
  showSpinner: false,
};
